import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Analytics } from 'packages';
import uiActions from 'state/actions/ui';
import { Image } from 'components';
import './video-carousel.scss';

const Video = ({ item, dispatch }) => {
    const handleVideoClick = videoId => {
        const title = item.text;
        dispatch(uiActions.openVideoModal({ videoId, title }));
        Analytics.trackEvent({
            category: 'How To Buy',
            action: 'VideoModal:Open',
            label: `${title} - Video id: ${videoId}`
        });
    };

    return (
        <div className="col">
            <div
                onClick={() => handleVideoClick(item.videoId)}
                style={{ cursor: 'pointer' }}>
                <picture>
                    <Image
                        src={item.image}
                        srcset={`${item.image} 400w`}
                        sizes={`(min-width: 0)`}
                        alt={`Spela video: ${item.text}`}
                        className="img-fluid video-carousel--img"
                    />
                </picture>
                {item.text && (
                    <div className="h5 mt-3">{item.text}</div>
                )}
            </div>
        </div>
    );
};

Video.propTypes = {
    item: PropTypes.shape({
        text: PropTypes.string,
        url: PropTypes.string,
        image: PropTypes.string.isRequired
    })
};
const mapStateToProps = (state, ownProps) => ({
    ...ownProps
});

export default connect(mapStateToProps)(Video);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/carousels/video-carousel/video.jsx